var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntertainment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1584_3700)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 3C16.1836 2.99995 17.8015 3.65316 19.0132 4.82209C20.2248 5.99102 20.9356 7.58449 20.996 9.267L21 9.5V15.5C21 17.1836 20.3468 18.8015 19.1779 20.0132C18.009 21.2248 16.4155 21.9356 14.733 21.996L14.5 22H9.5C7.8164 22 6.19847 21.3468 4.98682 20.1779C3.77518 19.009 3.06435 17.4155 3.004 15.733L3 15.5V9.5C2.99995 7.8164 3.65316 6.19847 4.82209 4.98682C5.99102 3.77518 7.58449 3.06435 9.267 3.004L9.5 3H14.5ZM18.431 7.308C18.3383 7.40267 18.2437 7.488 18.147 7.564C17.719 7.902 17.16 8.163 16.559 8.363C15.346 8.767 13.734 9 12 9C10.266 9 8.654 8.767 7.441 8.363C6.84 8.163 6.281 7.902 5.853 7.563C5.75302 7.48411 5.65816 7.39894 5.569 7.308C5.23903 7.90051 5.04725 8.55994 5.008 9.237L5 9.5V15.5C5 16.6568 5.44547 17.7691 6.24393 18.6061C7.04239 19.4431 8.13251 19.9405 9.288 19.995L9.5 20H14.5C15.6568 20 16.7691 19.5545 17.6061 18.7561C18.4431 17.9576 18.9405 16.8675 18.995 15.712L19 15.5V9.5C19.0003 8.73277 18.8044 7.97821 18.431 7.308ZM12 5C10.42 5 9.032 5.215 8.074 5.534C7.597 5.694 7.279 5.861 7.099 6C7.279 6.14 7.597 6.307 8.074 6.466C9.032 6.786 10.42 7 12 7C13.58 7 14.967 6.785 15.926 6.466C16.403 6.306 16.721 6.139 16.901 6C16.721 5.86 16.403 5.693 15.926 5.534C14.967 5.214 13.58 5 12 5Z",
    fill: "#292929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1584_3700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.e5b23f625932bf9434cc8605bd8f9959.svg";
export { ForwardRef as ReactComponent };